import { render, staticRenderFns } from "./SidebarFilter.vue?vue&type=template&id=fbe3cde6&scoped=true"
import script from "./SidebarFilter.vue?vue&type=script&lang=js"
export * from "./SidebarFilter.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilter.vue?vue&type=style&index=0&id=fbe3cde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe3cde6",
  null
  
)

export default component.exports